import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface HelpCircleIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const HelpCircleIcon = ({ className, ...props }: HelpCircleIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM11.4521 17.4971C11.7292 17.1892 12.2038 17.1643 12.5117 17.4414C12.8196 17.7185 12.8445 18.1931 12.5674 18.501L12.5576 18.5117C12.2805 18.8196 11.8059 18.8445 11.498 18.5674C11.1903 18.2903 11.1653 17.8156 11.4424 17.5078L11.4521 17.4971ZM11.75 5.625C12.5881 5.625 13.4555 5.89017 14.126 6.45898C14.8128 7.04171 15.25 7.90898 15.25 9C15.25 9.76587 15.0538 10.3495 14.7334 10.8301C14.4348 11.278 14.0372 11.6134 13.752 11.8701C13.4448 12.1466 13.2127 12.374 13.043 12.6738C12.8806 12.9607 12.75 13.3617 12.75 14C12.75 14.4142 12.4142 14.75 12 14.75C11.5858 14.75 11.25 14.4142 11.25 14C11.25 13.1384 11.4319 12.4768 11.7383 11.9355C12.0373 11.4073 12.4302 11.0409 12.748 10.7549C13.0878 10.4491 13.3152 10.2532 13.4854 9.99805C13.6337 9.77555 13.75 9.48412 13.75 9C13.75 8.3411 13.4997 7.8958 13.1553 7.60352C12.7945 7.2974 12.2869 7.125 11.75 7.125C11.2131 7.125 10.7055 7.2974 10.3447 7.60352C10.0003 7.8958 9.75 8.34109 9.75 9C9.75 9.41421 9.41421 9.75 9 9.75C8.58579 9.75 8.25 9.41421 8.25 9C8.25 7.90898 8.68725 7.04171 9.37402 6.45898C10.0445 5.89016 10.9119 5.625 11.75 5.625Z"
      fill="currentColor"
    />
  </svg>
);

export default HelpCircleIcon;
